import BodyText from '@lyra/core/components/BodyText'
import { InstrumentType } from '@lyra/web/constants/instruments'
import {
  formatInstrument,
  formatOptionExpiry,
  parseInstrumentName,
} from '@lyra/web/utils/instruments'
import React from 'react'
import { XStack, YStack } from 'tamagui'

import MarketIcon from './MarketIcon'

type Props = {
  instrumentName: string
}

export default function InstrumentCell({ instrumentName }: Props) {
  const instrument = parseInstrumentName(instrumentName)
  if (!instrument) {
    return null
  }
  return (
    <XStack alignItems="center" gap="$1">
      <MarketIcon marketId={instrument.marketId} />
      <YStack>
        <BodyText>{formatInstrument(instrumentName)}</BodyText>
        <BodyText color="secondary">
          {instrument.type === 'option'
            ? formatOptionExpiry(instrumentName)
            : instrument.type === InstrumentType.Spot
            ? instrumentName
            : `${instrument.marketId}-USD`}
        </BodyText>
      </YStack>
    </XStack>
  )
}
